import {MenuCategoryWithSlimProducts} from "./menu-category-with-slim-products";

export class ProductListGroupedByCategoryResponse {
    public categories: MenuCategoryWithSlimProducts[] = [];

    constructor() {
    }
}